import React, { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Loading, fmtDate } from "../portal/ui";

export default function ActivityLog() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/platform/activity").then(({ data }) => setRows(data)); }, []);
  const filtered = useMemo(() => {
    const t = q.toLowerCase();
    return (rows || []).filter((r) => !t || [r.action, r.target, r.actor_name, r.actor_email].some((v) => (v || "").toLowerCase().includes(t)));
  }, [rows, q]);
  if (!rows) return <Loading />;
  return (
    <div data-testid="control-activity">
      <PageTitle eyebrow="Platform Administration" title="Activity Log" sub="Every administrative and editorial action, newest first." />
      <div className="relative mb-6 max-w-md">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-stonegrey" />
        <input className="input-lodge !pl-11" placeholder="Search by person, action or item" value={q} onChange={(e) => setQ(e.target.value)} data-testid="activity-search" />
      </div>
      <Card className="overflow-x-auto !p-0">
        <table className="w-full min-w-[720px] font-sans text-sm">
          <thead>
            <tr className="border-b border-sapphire-deep/10 text-left text-[11px] uppercase tracking-widest text-stonegrey">
              <th className="px-6 py-4">When</th><th className="px-4 py-4">Who</th><th className="px-4 py-4">Action</th><th className="px-4 py-4">Item</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} className="border-b border-sapphire-deep/5" data-testid="activity-row">
                <td className="whitespace-nowrap px-6 py-3 text-xs text-stonegrey">{fmtDate(r.at, true)}</td>
                <td className="px-4 py-3"><p className="text-sapphire-deep">{r.actor_name || "—"}</p><p className="text-[11px] text-stonegrey">{r.actor_email}</p></td>
                <td className={`px-4 py-3 ${r.action.startsWith("Failed") ? "font-semibold text-garnet" : "text-charcoal"}`}>{r.action}</td>
                <td className="px-4 py-3 text-gold-deep">{r.target}{r.detail && <span className="block text-[11px] text-stonegrey">{r.detail}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!filtered.length && <p className="p-6 font-sans text-sm text-stonegrey" data-testid="activity-empty">No matching activity.</p>}
      </Card>
    </div>
  );
}
